 <div class="loading-wrapper" *ngIf="isLoadingdb">
  <div class="top-bar">
    <!-- <button class="back-btn">←</button>
    <span>Refreshing Media Contents</span> -->
  </div>

  <div class="status-container">
    <div class="status-box" *ngFor="let item of loadingItems" [ngClass]="{ 'spin-border': !item.loaded, 'loaded-border': item.loaded }">
    <div class="card-lable">

      <div class="label">{{ item.label }}</div>
      <div class="d-flex">
        <div class="status"
        [ngClass]="{ 'complete': item.loaded, 'downloading': !item.loaded }"
        >
        {{ item.loaded ? 'Completed' : 'Downloading...' }}
      </div>
    </div>
  </div>
  </div>
  </div>

  <div class="spinner"></div>
  <div class="bottom-bar">PLEASE WAIT...</div>
</div>

<div class="container-fluid auth-background p-3">
  <div class="d-flex align-items-center justify-content-between mobile">
    <div class="profile-title">
      <h2 class="title">Choose your Profile</h2>

    </div>
    
    <div class="action-buttons">
      <button class="btn" routerLink="/playlist"><i class="fas fa-exchange-alt mr-2"></i>Switch Playlist</button>
      <button class="btn" (click)="editMode()"><i class="fa fa-edit fs-18 mr-2"></i>Edit</button>
      <button class="btn" (click)="deleteMode()"><i class="fas fa-trash-alt mr-2"></i>Delete</button>
    </div>
  </div>
  <div class="profile-container">
    <div class="profiles">
      <div class="profile position-relative" *ngFor="let profile of profiles">
        <div class="absolute" *ngIf="isDeleteMode || isEditMode">
          <i class="delete-icon" *ngIf="isDeleteMode" (click)="deleteProfile(profile.profile.profile_id)" ><i class=" fa fa-trash-alt fs-22"></i></i>
          <i class="delete-icon" *ngIf="isEditMode" ><i class="fa fa-edit fs-22" (click)="editProfile(profile.profile.profile_id)"></i></i>
        </div>
        <div class="avatar-wrapper">
          <img [src]="profile.profile.profile_image || '/assets/images/userProfile.png'" alt="" height="200px" width="200px" (click)="loginPlaylist(profile.profile)" (error)="handleImageError($event)" class="avatar" />
  
        </div>
        <div class="name">
        {{profile.profile.profile_name}}
        <span *ngIf="profile.profile.pin" >
          <img src="/assets/images/lock.svg" height="20px" width="20px"  alt="">
        </span>
        </div>
      </div>
  
      <div class="profile add-profile" (click)="creteProfile()" *ngIf="profiles.length < 5 ">
        <div class="avatar-wrapper">
          <div class="add-icon">+</div>
        </div>
        <div class="name">Add Profile</div>
      </div>
    </div>
  </div>
</div>


<!-- <div class="pin-modal" *ngIf="showPinModal">
  <div class="pin-content">
    <h4 class="mt-2">Enter PIN</h4>
    <input type="password" placeholder="Enter Pin" [(ngModel)]="enteredPin" maxlength="4" class="form-control mb-2 mt-3" />
    <div *ngIf="pinError" class="text-danger fs-14 d-flex align-items-center">Incorrect PIN. Please try again.</div>
    <div class="mt-3 d-flex justify-content-between">
      <button class="btn btn-submit" (click)="verifyPin()">Submit</button>
      <button class="btn btn-cancel ml-2" (click)="cancelPin()">Cancel</button>
    </div>
  </div>
</div> -->
<div class="pin-modal" *ngIf="showPinModal">
  <div class="pin-content text-center">
    <h4 class="mt-2">Enter PIN</h4>
    
    <div class="d-flex justify-content-center gap-2 mt-3">
      <!-- <input
        *ngFor="let digit of pinDigits; let i = index"
        [(ngModel)]="enteredPinArray[i]"
        maxlength="1"
        class="form-control text-center otp-input"
        (input)="moveToNext($event, i)"
        (keydown)="handleBackspace($event, i)"
        inputmode="numeric"
        pattern="[0-9]*"
        type="password"
      /> -->
      <input
  #pinInputRef
  *ngFor="let digit of pinDigits; let i = index"
  [(ngModel)]="enteredPinArray[i]"
  maxlength="1"
  class="form-control text-center otp-input"
  (input)="moveToNext($event, i)"
  (keydown)="handleBackspace($event, i)"
  (keyup.enter)="verifyPin()"
  inputmode="numeric"
  pattern="[0-9]*"
  type="password"
/>

    </div>

    <div *ngIf="pinError" class="text-danger fs-14 d-flex align-items-center justify-content-center mt-2">
      Incorrect PIN. Please try again.
    </div>

    <div class="mt-3 d-flex justify-content-center">
      <button class="btn btn-submit" (click)="verifyPin()">Submit</button>
      <button class="btn btn-cancel ml-2" (click)="cancelPin()">Cancel</button>
    </div>
  </div>
</div>


<!-- <div class="container-fluid auth-background">
    <div class="switch-playlist d-flex justify-content-end">
      <button class="btn btn-switch mt-4" routerLink="/playlist"> <i class="fas fa-exchange-alt mr-2"></i>Switch Playlist</button>
    </div>
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="header-w3l">
          <div class="logo ml-2">
            <h3 class="mt-5">
              <a href="#">{{ "COMMON.TITLE" | translate }}</a>
            </h3>
          </div>
        </div>

        <div class="add-profile">
            <h2 class="d-flex justify-content-center align-items-center">Choose your Profile</h2>
        </div>
        <div class="d-flex justify-content-center align-items-center main-card">
            
            <div class="circle-card position-relative p-5 mt-5"  *ngFor="let item of profiles" >
                <span class="delete-profile"><i class="fa fa-trash fs-22 text-danger" (click)="deleteProfile(item.profile.profile_id)"></i></span>
                <span class="edit-profile"> <i class="fa fa-edit fs-22"  (click)="addProfile(item.profile.profile_id)"></i></span>
                <div class="profile-img">
                    <img [src]="item.profile.profile_image || '/assets/images/girl.png'" alt="" height="200px" width="200px" (click)="loginPlaylist(item.profile)" (error)="handleImageError($event)">
                </div>
                <div class="title">
                  <h4 class="d-flex justify-content-center mt-3">
                      {{item.profile.profile_name}}
                  </h4>  
                </div>
            </div>
            <div class="circle-card  p-5 mt-5">
              <div class="profile-img">
                <img src="/assets/images/new_login_flow/add-profile.png" alt=""  height="190px" width="190px" (click)="creteProfile()">
              </div>
              <div class="title">
                <h4 class="d-flex justify-content-center mt-4">
                    Add Profile
                </h4>  
              </div>
          </div>
        </div>
      </div>
    </div>
</div> -->